<template>
    <div>
        <div class="mb-3">
            <sav-input
            test-id-value="inp-password"
            class="mb-3"
            :label="$t('composants.sav-input-password.mot_de_passe')"
            type="password"
            v-model="passwordInput"
            :errors="errors"
            />
            <div class="flex items-center pb-1">
                <div class="mr-5">
                    <!-- 8 caractères -->
                    <div class="flex items-center mt-1 text-sm font-light">
                        <div class="w-2 h-2 mr-2 bg-gray-500 rounded-full" v-if="!passwordErrors.minSize.check"></div>
                        <div v-show="passwordErrors.minSize.check"><i class="mr-1 text-green-500 fas fa-check"></i></div>
                        <span :class="passwordErrors.minSize.check ? 'text-green-500' : (passwordErrors.minSize.error ? 'text-red-500' : 'text-gray-500')">{{$t('composants.sav-input-password.6_carac')}}</span>
                    </div>
                    <!-- Majuscule -->
                    <div class="flex items-center mt-1 text-sm font-light">
                        <div class="w-2 h-2 mr-2 bg-gray-500 rounded-full" v-if="!passwordErrors.uppercase.check"></div>
                        <div v-show="passwordErrors.uppercase.check"><i class="mr-1 text-green-500 fas fa-check"></i></div>
                        <span :class="passwordErrors.uppercase.check ? 'text-green-500' : (passwordErrors.uppercase.error ? 'text-red-500' : 'text-gray-500')">
                            {{$t('composants.sav-input-password.majuscule')}}
                        </span>
                    </div>
                </div>
                <div>
                    <!-- Chiffre -->
                    <div class="flex items-center mt-1 text-sm font-light">
                        <div class="w-2 h-2 mr-2 bg-gray-500 rounded-full" v-if="!passwordErrors.digit.check"></div>
                        <div v-show="passwordErrors.digit.check"><i class="mr-1 text-green-500 fas fa-check"></i></div>
                        <span :class="passwordErrors.digit.check ? 'text-green-500' : (passwordErrors.digit.error ? 'text-red-500' : 'text-gray-500')">{{$t('composants.sav-input-password.chiffre')}}</span>
                    </div>
                    <!-- Caractere special -->
                    <div class="flex items-center mt-1 text-sm font-light">
                        <div class="w-2 h-2 mr-2 bg-gray-500 rounded-full" v-if="!passwordErrors.special.check"></div>
                        <div v-show="passwordErrors.special.check"><i class="mr-1 text-green-500 fas fa-check"></i></div>
                        <span :class="passwordErrors.special.check ? 'text-green-500' : (passwordErrors.special.error ? 'text-red-500' : 'text-gray-500')">{{$t('composants.sav-input-password.caractere_special')}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <!-- Confirm password -->
            <sav-input
            class="mb-3"
            :label="$t('composants.sav-input-password.confirmer_le_mot_de_passe')"
            type="password"
            :errors="repasswordErrors"
            v-model="repasswordInput"
            test-id-value="inp-repassword"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errors: {}
    },
    watch: {
        passwordInput: {
            deep: true,
            handler: function(value) {
                const regexSpecialCharacter = /(?=.*?[#?!@$%^&*-])/
                const regexDigit = /(?=.*?[0-9])/
                const regexUppercase = /(?=.*?[A-Z])/

                this.passwordErrors.minSize.check = value.length >= 8
                this.passwordErrors.special.check = regexSpecialCharacter.test(value)
                this.passwordErrors.digit.check = regexDigit.test(value)
                this.passwordErrors.uppercase.check = regexUppercase.test(value)
                
                this.emitData()
            }
        },
        repasswordInput: function(value) {
            this.emitData()
        }
    },

    data() {
        return {
            passwordInput: null,
            passwordErrors: {
                minSize: {check: false, error: false},
                uppercase: {check: false, error: false},
                digit: {check: false, error: false},
                special: {check: false, error: false}
            },
            repasswordInput: null,
            repasswordErrors: [],
        }
    },

    methods: {
        validation() {
            let hasError = false

            for (let checkIndex in this.passwordErrors) {
                if (!this.passwordErrors[checkIndex].check) {
                    this.passwordErrors[checkIndex].error = true
                    hasError = true
                } else {
                    this.passwordErrors[checkIndex].error = false
                }
            }

            this.repasswordErrors = []
            if (!this.repasswordInput) {
                this.repasswordErrors.push(this.$t('composants.sav-input-password.champ_incomplet'))
            } else if (this.passwordInput != this.repasswordInput) {
                this.repasswordErrors.push(this.$t('composants.sav-input-password.les_mots_de_passe_ne_correspondent_pas'))
            }

            if (!this.repasswordInput || this.passwordInput != this.repasswordInput) {
                hasError = true
            }
            return !hasError
        },

        emitData() {
            this.$emit('input', {
                password: this.passwordInput,
                repassword: this.repasswordInput,
                valid: this.validation()
            })
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/SavInputPassword.vue